webpackJsonp([221574975059773],{

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.GridItem = exports.Grid = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFlipMove = __webpack_require__(148);
	
	var _reactFlipMove2 = _interopRequireDefault(_reactFlipMove);
	
	var _gridModule = __webpack_require__(144);
	
	var _gridModule2 = _interopRequireDefault(_gridModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GridItem = function (_React$PureComponent) {
	  _inherits(GridItem, _React$PureComponent);
	
	  function GridItem() {
	    _classCallCheck(this, GridItem);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  GridItem.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        size = _props.size;
	
	    var classNames = [_gridModule2.default['gridItem--' + size]];
	
	    if (className) {
	      classNames.push(className);
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: classNames.join(' ') },
	      _react2.default.createElement(
	        'div',
	        { className: _gridModule2.default.gridItemContentWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _gridModule2.default.gridItemContent },
	          this.props.children
	        )
	      )
	    );
	  };
	
	  return GridItem;
	}(_react2.default.PureComponent);
	
	GridItem.propTypes = {
	  size: _propTypes2.default.string.isRequired,
	  className: _propTypes2.default.string
	};
	
	GridItem.defaultProps = {
	  size: '1x1'
	};
	
	var Grid = function (_React$PureComponent2) {
	  _inherits(Grid, _React$PureComponent2);
	
	  function Grid() {
	    _classCallCheck(this, Grid);
	
	    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
	  }
	
	  Grid.prototype.renderChildren = function renderChildren() {
	    var children = this.props.children;
	
	    var test = [];
	    // generate rows
	    _react2.default.Children.forEach(children, function (child) {
	      test.push(child);
	    });
	
	    return test;
	  };
	
	  Grid.prototype.render = function render() {
	    var _this3 = this;
	
	    var classes = [_gridModule2.default.grid];
	
	    if (this.props.className) {
	      classes.push(this.props.className);
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: _gridModule2.default.container },
	      this.props.flip ? _react2.default.createElement(
	        _reactFlipMove2.default,
	        {
	          easing: 'ease-out',
	          className: classes.join(' '),
	          duration: 250,
	          staggerDurationBy: 50,
	          staggerDelayBy: 50,
	          onStartAll: function onStartAll() {
	            if (_this3.props.onFlipStart) {
	              _this3.props.onFlipStart();
	            }
	          },
	          onFinishAll: function onFinishAll() {
	            if (_this3.props.onFlipFinish) {
	              _this3.props.onFlipFinish();
	            }
	          }
	        },
	        this.renderChildren()
	      ) : _react2.default.createElement(
	        'div',
	        { className: classes.join(' ') },
	        this.props.children
	      )
	    );
	  };
	
	  return Grid;
	}(_react2.default.PureComponent);
	
	exports.Grid = Grid;
	exports.GridItem = GridItem;

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lazyImage = __webpack_require__(12);
	
	var _portfolioModule = __webpack_require__(87);
	
	var _portfolioModule2 = _interopRequireDefault(_portfolioModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var item = _portfolioModule2.default.item,
	    imageClass = _portfolioModule2.default.image,
	    backgroundClass = _portfolioModule2.default.background;
	
	var PortoflioItem = function (_React$PureComponent) {
	  _inherits(PortoflioItem, _React$PureComponent);
	
	  function PortoflioItem() {
	    _classCallCheck(this, PortoflioItem);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  PortoflioItem.prototype.render = function render() {
	    var _props = this.props,
	        image = _props.image,
	        title = _props.title,
	        permalink = _props.permalink,
	        size = _props.size;
	
	
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: permalink, className: item },
	      _react2.default.createElement(_lazyImage.Image, {
	        style: { position: 'absolute' },
	        sizes: image,
	        alt: title,
	        className: imageClass
	      }),
	      _react2.default.createElement('div', { className: backgroundClass }),
	      _react2.default.createElement(
	        'div',
	        { className: _portfolioModule2.default.titleWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _portfolioModule2.default.title },
	          title
	        )
	      )
	    );
	  };
	
	  return PortoflioItem;
	}(_react2.default.PureComponent);
	
	PortoflioItem.propTypes = {
	  title: _propTypes2.default.any,
	  image: _propTypes2.default.any,
	  permalink: _propTypes2.default.string.isRequired
	};
	
	PortoflioItem.defaultProps = {
	  title: 'nazwa firmy tytuł projektu trzy linijki',
	  permalink: '/#'
	};
	
	exports.default = PortoflioItem;
	module.exports = exports['default'];

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// import Page from '../../page';
	
	//
	
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lazyImage = __webpack_require__(12);
	
	var _headerSpacer = __webpack_require__(20);
	
	var _headerSpacer2 = _interopRequireDefault(_headerSpacer);
	
	var _navigation = __webpack_require__(24);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _grid = __webpack_require__(111);
	
	var _item = __webpack_require__(114);
	
	var _item2 = _interopRequireDefault(_item);
	
	var _portfolioSingleModule = __webpack_require__(400);
	
	var _portfolioSingleModule2 = _interopRequireDefault(_portfolioSingleModule);
	
	var _globalState = __webpack_require__(6);
	
	var _globalState2 = _interopRequireDefault(_globalState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function prepareImageSizes(prepare, item) {
	  var sizes = _extends({}, prepare[item.tall ? 'res_' + item.wide : 'sizes']);
	
	  return sizes;
	}
	
	var PortfolioSingleComponent = function (_React$PureComponent) {
	  _inherits(PortfolioSingleComponent, _React$PureComponent);
	
	  function PortfolioSingleComponent(props) {
	    _classCallCheck(this, PortfolioSingleComponent);
	
	    // this.setSizeState = this.setSizeState.bind(this)
	    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));
	
	    _this.state = {
	      twocolumns: false
	    };
	    return _this;
	  }
	
	  PortfolioSingleComponent.prototype.onMountGlobalState = function onMountGlobalState(state) {
	    return _extends({}, state, {
	      whiteLogo: false
	    });
	  };
	
	  // renderItem__(item, index) {
	  //   let type = null,
	  //     elem = null
	
	  //   if (item.__typename === 'WordPressAcf_text' && item.text) {
	  //     type = 'text'
	  //     elem = (
	  //       <div
	  //         className="styled-content"
	  //         dangerouslySetInnerHTML={{
	  //           __html: item.text,
	  //         }}
	  //       />
	  //     )
	  //   } else if (item.__typename === 'WordPressAcf_image' && item.obrazek) {
	  //     type = 'image'
	  //     elem = (
	  //       <Image
	  //         sizes={prepareImageSizes(
	  //           item.obrazek.localFile.childImageSharp,
	  //           item
	  //         )}
	  //       />
	  //     )
	  //   }
	
	  //   if (type && elem) {
	  //     return (
	  //       <div
	  //         key={`item_${index}`}
	  //         className={[Styles[`wide_${item.wide}`], Styles[`item_${type}`]].join(
	  //           ' '
	  //         )}
	  //       >
	  //         {elem}
	  //       </div>
	  //     )
	  //   }
	  //   return null
	  // }
	
	  PortfolioSingleComponent.prototype.renderItem2 = function renderItem2(item, index) {
	    var elem = null;
	
	    if (item.type === 'image' && item.croppedImage) {
	      elem = _react2.default.createElement(_lazyImage.Image, { sizes: item.croppedImage });
	    } else if (item.type === 'text' && item.text) {
	      elem = _react2.default.createElement('div', {
	        className: 'styled-content',
	        dangerouslySetInnerHTML: {
	          __html: item.text
	        }
	      });
	    }
	
	    // const classNames = [
	    //   Styles[`portfolioItem--${item.size}`],
	    //   Styles[`portfolioItem--${item.type}`],
	    // ]
	
	    if (elem) {
	      return _react2.default.createElement(
	        _grid.GridItem,
	        {
	          key: 'item_' + index,
	          size: item.size,
	          className: _portfolioSingleModule2.default['portfolioItem--' + item.type]
	        },
	        elem
	      )
	      // <div key={`item_${index}`} className={classNames.join(' ')}>
	      //   {elem}
	      // </div>
	      ;
	    }
	    //
	    return null;
	  };
	
	  // componentDidMount() {
	  //   const desktopViewport = window.matchMedia('(min-width: 1500px)')
	  //   desktopViewport.addListener(this.setSizeState)
	  //   this.setSizeState(desktopViewport)
	  // }
	
	  // setSizeState(mq) {
	  //   this.setState(state => ({
	  //     ...state,
	  //     twocolumns: mq.matches,
	  //   }))
	  // }
	
	  // renderItems() {
	  //   const { twocolumns } = this.state
	  //   const items = this.props.data.portfolio.acf.content
	
	  //   let rows = 0
	  //   if (twocolumns) {
	  //     return '2 kolumns'
	  //   } else {
	  //     return items.map(this.renderItem2)
	  //   }
	  // }
	
	  PortfolioSingleComponent.prototype.render = function render() {
	    // if (
	    //   this.props.data.portfolio.featured_media &&
	    //   !this.props.data.portfolio.featured_media.localFile
	    // ) {
	    //   console.log('')
	    //   console.log('')
	    //   console.log(`we have error`, this.props.data.portfolio.title)
	    //   console.log(`rest`, this.props.data.portfolio)
	    //   console.log('')
	    //   console.log('')
	    // }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.props.data.portfolio.acf.show_header_spacer && _react2.default.createElement(_headerSpacer2.default, null),
	      _react2.default.createElement(
	        _grid.Grid,
	        null,
	        this.props.data.portfolio.acf.show_featured_image && this.props.data.portfolio.featured_media &&
	        // <div
	        //   style={{
	        //     margin: '0 12px 24px',
	        //     flexGrow: 1,
	        //     flexShrink: 1,
	        //     flexBasis: `${18 * 100}px`,
	        //   }}
	        // >
	        _react2.default.createElement(
	          _grid.GridItem,
	          { size: '2x2' },
	          _react2.default.createElement(_lazyImage.Image, {
	            backgroundColor: this.props.data.portfolio.featured_media.localFile.childImageSharp.bgColor,
	            sizes: this.props.data.portfolio.featured_media.localFile.childImageSharp.res_100
	          })
	        ),
	        this.props.data.portfolio.tiles.map(this.renderItem2)
	      ),
	      _react2.default.createElement(_navigation2.default, {
	        type: 'portfolio',
	        prev: this.props.data.prev,
	        next: this.props.data.next
	      })
	    );
	  };
	
	  return PortfolioSingleComponent;
	}(_react2.default.PureComponent);
	
	exports.default = PortfolioSingleComponent;
	module.exports = exports['default'];

/***/ }),

/***/ 144:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-styles-components----grid-module---container---3OD6v src-styles-components----container-module---container---1YJKJ","grid":"src-styles-components----grid-module---grid---1h1zR","gridItem":"src-styles-components----grid-module---gridItem---MD9uo","gridItemContentWrapper":"src-styles-components----grid-module---gridItemContentWrapper---K1dzV","gridItemContent":"src-styles-components----grid-module---gridItemContent---1NHz9","gridItem--1x1":"src-styles-components----grid-module---gridItem--1x1---3PW2Y src-styles-components----grid-module---gridItem---MD9uo","gridItem--2x2":"src-styles-components----grid-module---gridItem--2x2---xIAS1 src-styles-components----grid-module---gridItem---MD9uo","gridItem--1x2":"src-styles-components----grid-module---gridItem--1x2---3hNuq src-styles-components----grid-module---gridItem---MD9uo"};

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"item":"src-styles-components----portfolio-module---item---2bT7E","image":"src-styles-components----portfolio-module---image---2HNcP","background":"src-styles-components----portfolio-module---background---2Vty3","titleWrapper":"src-styles-components----portfolio-module---titleWrapper---3XK6v","title":"src-styles-components----portfolio-module---title---1gVmS"};

/***/ }),

/***/ 400:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"portfolioGrid":"src-styles-components----portfolioSingle-module---portfolioGrid---2Q16R","portfolioItem":"src-styles-components----portfolioSingle-module---portfolioItem---1M8p5","portfolioItem--text":"src-styles-components----portfolioSingle-module---portfolioItem--text---1PNGP","portfolioItem--1x1":"src-styles-components----portfolioSingle-module---portfolioItem--1x1---3Nkwg src-styles-components----portfolioSingle-module---portfolioItem---1M8p5","portfolioItem--2x2":"src-styles-components----portfolioSingle-module---portfolioItem--2x2---2fsv6 src-styles-components----portfolioSingle-module---portfolioItem---1M8p5","portfolioItem--1x2":"src-styles-components----portfolioSingle-module---portfolioItem--1x2---v7hjk src-styles-components----portfolioSingle-module---portfolioItem---1M8p5","wide_100":"src-styles-components----portfolioSingle-module---wide_100---fez20","wide_75":"src-styles-components----portfolioSingle-module---wide_75---1hS07","wide_50":"src-styles-components----portfolioSingle-module---wide_50---1t0RV","wide_25":"src-styles-components----portfolioSingle-module---wide_25---2wQrV","item_text":"src-styles-components----portfolioSingle-module---item_text---2lvNk","wp-caption":"src-styles-components----portfolioSingle-module---wp-caption---3YW3E","h100":"src-styles-components----portfolioSingle-module---h100---1bj42"};

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _page = __webpack_require__(17);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _portfolioSingle = __webpack_require__(240);
	
	var _portfolioSingle2 = _interopRequireDefault(_portfolioSingle);
	
	var _seo = __webpack_require__(32);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PortfolioSinglePage = function (_Page) {
	  _inherits(PortfolioSinglePage, _Page);
	
	  function PortfolioSinglePage() {
	    _classCallCheck(this, PortfolioSinglePage);
	
	    return _possibleConstructorReturn(this, _Page.apply(this, arguments));
	  }
	
	  PortfolioSinglePage.prototype.onMountGlobalState = function onMountGlobalState(state) {
	    return _extends({}, state, {
	      whiteLogo: false
	    });
	  };
	
	  PortfolioSinglePage.prototype.render = function render() {
	    return [_react2.default.createElement(_seo2.default, _extends({}, this.props.data.portfolio, this.props.pathContext, {
	      key: 'seo'
	    })), _react2.default.createElement(_portfolioSingle2.default, { data: this.props.data, key: 'page' })];
	  };
	
	  return PortfolioSinglePage;
	}(_page2.default);
	
	exports.default = PortfolioSinglePage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	/*
	// layout_portfolio {
	        //   __typename
	        //   ... on WordPressAcf_image {
	        //     wide
	        //     tall
	        //     obrazek {
	        //       localFile {
	        //         childImageSharp {
	        //           sizes(maxWidth: 1885, traceSVG: { color: "#821749" }) {
	        //             ...GatsbyImageSharpSizes_withWebp
	        //           }
	        //           res_100: sizes(
	        //             maxWidth: 1885
	        //             maxHeight: 1060
	        //             traceSVG: { color: "#821749" }
	        //           ) {
	        //             ...GatsbyImageSharpSizes_withWebp
	        //           }
	        //           res_75: sizes(
	        //             maxWidth: 1403
	        //             maxHeight: 1060
	        //             traceSVG: { color: "#821749" }
	        //           ) {
	        //             ...GatsbyImageSharpSizes_withWebp
	        //           }
	        //           res_50: sizes(
	        //             maxWidth: 922
	        //             maxHeight: 1060
	        //             traceSVG: { color: "#821749" }
	        //           ) {
	        //             ...GatsbyImageSharpSizes_withWebp
	        //           }
	        //           res_25: sizes(
	        //             maxWidth: 441
	        //             maxHeight: 1060
	        //             traceSVG: { color: "#821749" }
	        //           ) {
	        //             ...GatsbyImageSharpSizes_withWebp
	        //           }
	        //         }
	        //       }
	        //     }
	        //   }
	        //   ... on WordPressAcf_text {
	        //     wide
	        //     text
	        //   }
	        // }
	        */

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-portfolio-single-js-61392f9f3f25303e6817.js